import { createStyles } from 'antd-style'

const PANEL_WIDTH_IN_CONTROLS = 13

export const useStyles = createStyles(({ token }) => ({
  panel: {
    width: token.controlHeight * PANEL_WIDTH_IN_CONTROLS
  },
  search: {
    marginInline: token.paddingSM,
    width: 'auto'
  }
}))
